// extracted by mini-css-extract-plugin
export var gif = "_ko-0";